import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme, isGlobetrotter } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';
import { focusOutline } from '../../utils/mixins.js';

var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var borderColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["var(--color-border-primary)"])), GLOBETROTTER, css(["var(--color-cta-button-primary)"])));
var borderWidth = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '2px'), GLOBETROTTER, '1px'));
var borderRadius = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '4px'), GLOBETROTTER, '1px'));
var CheckboxWrapper = styled.div.withConfig({
  displayName: "style__CheckboxWrapper",
  componentId: "sc-1cm7wqy-0"
})(["display:", ";position:relative;"], function (props) {
  return props.children ? 'flex' : 'inline-block';
});
var Input = styled.input.withConfig({
  displayName: "style__Input",
  componentId: "sc-1cm7wqy-1"
})(["display:inline;height:1px;opacity:0;position:absolute;width:1px;"]);
var Label = styled.label.withConfig({
  displayName: "style__Label",
  componentId: "sc-1cm7wqy-2"
})(["cursor:pointer;display:flex;min-height:2.4rem;position:relative;user-select:none;", " ", " .sg-checkbox-icon{position:absolute;height:2rem;width:2rem;left:0.2rem;top:0.2rem;z-index:1;color:var(--color-white);padding:0.2rem;", "}", ":focus-visible + &{", "}"], function (props) {
  return props.$disabled && css(["cursor:default;"]);
}, function (props) {
  return props.$fullWidthLabel && css(["width:100%;"]);
}, isGlobetrotter(css(["border:solid 0.15rem var(--color-white);"])), Input, focusOutline);
var Square = styled.span.withConfig({
  displayName: "style__Square",
  componentId: "sc-1cm7wqy-3"
})(["align-items:center;background:var(--color-white);border:", " solid ", ";border-radius:", ";color:var(--color-white);display:inline-flex;flex-shrink:0;height:2.4rem;justify-content:center;position:relative;transition:background var(--transition);width:2.4rem;", " ", " ", ""], borderWidth, borderColor, borderRadius, mq.retina(css(["", ""], isGlobetrotter(css(["border-width:0.15rem;"])))), function (props) {
  return props.$checked && css(["background:var(--color-cta-button-primary);border-color:var(--color-cta-button-primary);", ""], isGlobetrotter(css(["background:var(--color-cta-button-primary-active);border-color:var(--color-cta-button-primary-active);"])));
}, function (props) {
  return props.$disabled && css(["background:var(--color-background-disabled);border-color:var(--color-border-disabled);"]);
});
var Content = styled.span.withConfig({
  displayName: "style__Content",
  componentId: "sc-1cm7wqy-4"
})(["align-items:center;display:inline-flex;font-family:var(--font-family-body);font-size:1.6rem;line-height:2rem;padding-left:10px;", ""], function (props) {
  return props.$disabled && css(["opacity:0.6;"]);
});

export { CheckboxWrapper, Content, Input, Label, Square };
//# sourceMappingURL=style.js.map
